module.exports = __webpack_public_path__ + "static/media/summaryIcon.d4cbd26c.svg";